import { I18n, I18nLocale, Uuid } from '../../models/Base';
import { RepositoryElement } from '../../models/Repository';
import { deepTransformDate, deepTransformTimestamp } from '../../utils/date';
import { createI18nInfo } from '../../utils/i18n';

export type RewardPlaform = Uuid;

type I18nRewardCategoryInfo = I18n<{
  name: string;
  shortDescription: string | null;
  description: string | null;
}>;

export interface RewardCategoryJson<T = number> {
  rewardCategoryId: Uuid;
  store: RewardPlaform;
  createdAt: T;
  lastModifiedAt: T;
  i18nRewardCategoryInfo: I18nRewardCategoryInfo;
  ordinal: string; // range(0,1)
}

export class RewardCategory
  extends RepositoryElement
  implements RewardCategoryJson<Date>
{
  readonly rewardCategoryId!: Uuid;
  store!: RewardPlaform;
  createdAt!: Date;
  lastModifiedAt!: Date;
  i18nRewardCategoryInfo!: I18nRewardCategoryInfo;
  ordinal!: string; // range(0,1)

  constructor(rewardCategory: RewardCategoryJson<Date | number>) {
    super();
    Object.assign(this, deepTransformTimestamp(rewardCategory));
  }

  static getAllCategoryId(store: RewardPlaform): string {
    return `${store}_all`;
  }
  static createAll(store: RewardPlaform): RewardCategory {
    return new RewardCategory({
      rewardCategoryId: this.getAllCategoryId(store),
      store,
      createdAt: Date.now(),
      lastModifiedAt: Date.now(),
      i18nRewardCategoryInfo: createI18nInfo(I18nLocale.US, {
        name: 'All',
        shortDescription: null,
        description: null,
      }),
      ordinal: '0',
    });
  }
  static getOrdinals(length: number): string[] {
    const sLength = Math.max(1, Math.ceil(Math.log10(length + 1)));
    return Array.from({ length }, (_, index) => {
      return ((10 * (sLength - 1) + index + 1) * Math.pow(0.1, sLength))
        .toFixed(sLength)
        .toString();
    });
  }

  id(): string {
    return this.rewardCategoryId;
  }

  toJSON(): RewardCategoryJson {
    return deepTransformDate(this) as unknown as RewardCategoryJson;
  }
}
